<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :row-style = "rowStyle"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <!--<template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.valuecostbudget_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>-->
      <template slot="projectIdSearch">
        <el-select
          v-model="projectName"
          @change="searchProjectChange"
        >
          <el-option
            v-for="item in projectList"
            :key="item"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          v-if="scope.row.releaseFlag==0"
          type="text"
          size="small"
          icon="el-icon-check"
          @click="release(scope.row)"
          style="color: #409EFF"
        >审核
        </el-button>
      </template>
      <template slot="notifyIdsForm" slot-scope="scope">
        <el-row>

          <el-col :span="19">
            <el-input readonly v-model="menberNames"></el-input>
            <el-input readonly v-model="form.notifyIds" style="display:none;"></el-input>
          </el-col>
          <el-col :span="5">
            <el-button :disabled="viewFlag" @click="handleEditGroup(form.flag)" type="primary">请选择</el-button>
          </el-col>
        </el-row>
      </template>
    </avue-crud>
    <el-dialog
      title="请选择人员"
      :visible.sync="dialogUserEditBoxVisible"
      fullscreen
      append-to-body
      width="80%"
    >
      <user-edit-box
        v-if="dialogUserEditBoxVisible"
        :remainUserListInside.sync="remainUserList"
        @closeAction="handleCloseAction"
        @submitAction="handleSubmitAction"
        @editAction="handleEditAction"
        :selectType.sync="selectUserType"
        :handleAction.sync="handleAction"
        :projectId.sync="tempProjectId"/>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {
    add,
    getDetail,
    getList,
    remove,
    update,
    release,
    getPeriodCost
  } from "@/api/crmedical/value/valuecostbudget";
  import {getPeriodList} from "@/api/crmedical/value/valuedatareported";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import dayjs from 'dayjs'
  import userEditBox from "./user-edit-box";
  import {userList} from "@/api/crmedical/contract/add/index";

  export default {
    components: {
      userEditBox
    },
    data() {
      return {
        projectName: '',
        form: {
          flag: '',

        },
        selectUserType: "",
        handleAction: '',
        menberNames: '',
        remainMenberUserList: [],
        remainUserList: [],
        dialogUserEditBoxVisible: false,
        dataSelectedPrincipalUsers: [],
        dataSelectedMenberUsers: [],
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        reWrite: false,
        tempProjectId: '',
        projectList: [],
        option: {
          height: 'auto',
          calcHeight: 50,
          tip: false,
          border: true,
          indexLabel: '序号',
          index: true,
          viewBtn: true,
          selection: true,
          columnBtn: false,
          refreshBtn: false,
          searchMenuSpan: 6,
          menuWidth: 250,
          align: 'center',
          column: [

            {
              label: "项目名称",
              prop: "projectId",
              type: 'tree',
              span: 8,
              cascaderItem: ['notifyIds'],
              editDisabled: true,
              searchslot: true,
              searchClearable: false,
              search: true,
              dicUrl: '/api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id'
              },
              rules: [
                {
                  required: true,
                  message: "请选择项目",
                  trigger: "change"
                }
              ]
            },
            {
              label: "计划周期",
              prop: "periodShow",
              span: 8,
              viewDisplay: false,
              addDisplay: false,
              editDisplay: false,
            },
            {
              label: "周期起",
              prop: "periodStart",
              search: false,
              hide: true,
              span: 8,
              type: "year",
              format: 'yyyy',
              valueFormat: 'yyyy-MM-dd 00:00:00',
              rules: [
                {
                  required: true,
                  message: "请选择周期",
                  trigger: "change"
                }
              ]
            },
            {
              label: "周期止",
              prop: "periodEnd",
              search: false,
              hide: true,
              span: 8,
              type: "year",
              format: 'yyyy',
              valueFormat: 'yyyy-MM-dd 00:00:00',
              rules: [
                {
                  required: true,
                  message: "请选择周期",
                  trigger: "change"
                },
                // {
                //       validator: (rule, value, callback) => {
                //         console.log(this.form.periodStart)
                //         console.log(value)
                //         var dateStart = Date.parse(this.form.periodStart);
                //         var dateEnd = Date.parse(value);
                //         if (dateStart >= dateEnd) {
                //           callback(new Error('周期止必须大于周期起！'));
                //         } else {
                //           callback();
                //         }
                //       },
                //       trigger: 'change',
                //     },

              ]
            },

            {
              label: "周期",
              prop: "period",
              type: 'select',
              search: true,
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
              hide: true,
              span: 8,
              dicData: [],
              props: {
                label: 'name',
                value: 'value'
              },
              rules: [
                {
                  required: true,
                  message: "请选择周期",
                  trigger: "change"
                }
              ]
            },

            {
              label: "成本来源",
              prop: "costSource",
              type: "select",
              span: 8,
              hide: true,
              search: false,
              dataType: 'number',
              dicUrl: '/api/blade-system/dict/dictionary?code=value_cost_source',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              rules: [
                {
                  required: true,
                  message: "请选择成本来源",
                  trigger: "change"
                }
              ]

            },
            {
              label: "成本基数",
              prop: "costBasis",
              span: 8,
              maxlength: 12,
              rules: [
                {
                  required: true,
                  message: "请输入成本基数",
                  trigger: "change"
                },
                {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
              ]
            },
            {
              label: "分享系数",
              prop: "sharingCoefficient",
              span: 8,
              rules: [
                {
                  required: true,
                  message: "请输入分享系数",
                  trigger: "change"
                },
                { pattern: /^(100(\.0{1,2})?)$|^([1-9]\d?(\.\d{1,2})?)$/,
                  message: '请输入100以内百分比数值',
                  trigger: "change"},
              ]
            },
            {
              label: "成本目标",
              prop: "targetCost",
              span: 8,
              maxlength: 12,
              rules: [
                {
                  required: true,
                  message: "请输入成本目标",
                  trigger: "change"
                },
                {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
              ]
            },
            {
              label: "创收目标",
              prop: "targetIncome",
              span: 8,
              maxlength: 12,
              rules: [
                {
                  required: true,
                  message: "请输入创收目标",
                  trigger: "change"
                },
                {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'},
              ]
            },
            {
              label: "临床基数",
              prop: "clinicalEvaluationBase",
              span: 8,
              //type:"number",
              maxlength: 5,
              max: 100,
              rules: [
                {
                  required: true,
                  message: "请输入临床评价基数",
                  trigger: "change"
                },
                {
                  pattern: /^(100(\.0{1,2})?)$|^([1-9]\d?(\.\d{1,2})?)$/,
                  message: '请输入100以内百分比数值',
                  trigger: "change"
                },
              ]
            },
            {
              label: "临床阈值",
              prop: "clinicalEvaluationThreshold",
              span: 8,
              maxlength: 5,
              max: 100,
              rules: [
                {
                  required: true,
                  message: "请输入临床评价阈值",
                  trigger: "change"
                },
                {
                  pattern: /^(100(\.0{1,2})?)$|^([1-9]\d?(\.\d{1,2})?)$/,
                  message: '请输入100以内百分比数值',
                  trigger: "change"
                },
              ]
            },
            {
              label: "患者基数",
              prop: "patientSatisfactionBase",
              span: 8,
              maxlength: 5,
              max: 100,
              rules: [
                {
                  required: true,
                  message: "请输入患者满意度基数",
                  trigger: "change"
                },
                {
                  pattern: /^(100(\.0{1,2})?)$|^([1-9]\d?(\.\d{1,2})?)$/,
                  message: '请输入100以内百分比数值',
                  trigger: "change"
                },
              ]
            },
            {
              label: "患者阈值",
              prop: "patientSatisfactionThreshold",
              span: 8,
              maxlength: 5,
              max: 100,
              rules: [
                {
                  required: true,
                  message: "请输入患者满意度阈值",
                  trigger: "change"
                },
                {
                  pattern: /^(100(\.0{1,2})?)$|^([1-9]\d?(\.\d{1,2})?)$/,
                  message: '请输入100以内百分比数值',
                  trigger: "change"
                },
              ]
            },

            // {
            //   label: "满意度低于阈值提醒",
            //   prop: "notifyWays",
            //   type: "tree",
            //   multiple: true,
            //   hide: true,
            //   search: false,
            //   labelWidth: 160,
            //   span: 10,
            //   dicUrl: 'api/blade-system/dict/dictionary?code=system_notify_way',
            //   props: {label: 'dictValue', value: 'dictKey'},
            //   rules: [{
            //     required: true,
            //     message: "请选择通知方式",
            //     trigger: "blur"
            //   }]
            // },
            //
            // {
            //   label: "提醒对象",
            //   prop: "notifyName",
            //   span: 14,
            //   search: false,
            //   hide: true,
            //   addDisplay: false,
            //   editDisplay: false,
            // },
            // {
            //   label: "提醒对象",
            //   prop: "notifyIds",
            //   type: "tree",
            //   formslot: true,
            //   multiple: true,
            //   hide: true,
            //   viewDisplay: false,
            //   span: 14,
            //   search: false,
            //   //dicUrl: '/api/v4ward/user/project-user-list?projectId={{projectId}}',
            //   //props: { label: 'realName', value: 'id' },
            //   rules: [{
            //     required: true,
            //     message: "请选择填报对象",
            //     trigger: "blur"
            //   }]
            // },
            {
              label: "发布标志位，0：发布前，1：发布后",
              prop: "releaseFlag",
              hide: true,
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
              rules: [{
                required: true,
                message: "请输入发布标志位，0：发布前，1：发布后",
                trigger: "change"
              }]
            },


          ]
        },
        viewFlag: false,
        data: []
      };
    },


    watch: {
      // 'form.period'() {
      //   this.form.costBasis = '';
      //   //this.form.costSource='';
      // },

      // 'form.costSource'(flag) {
      //   this.form.costBasis = '';
      //   if (this.form.flag === 'add') {
      //     // const column = this.findObject(this.option.column, 'costBasis');
      //     if (this.form.costSource === 1) {
      //       // setTimeout(() => {
      //       //   const column2 = this.findObject(this.option.column, 'costBasis');
      //       //   console.log(column2);
      //       //   column2.editDisabled = true;
      //       //   column2.addDisabled = true;
      //       // },);
      //       this.form.subjectId = '';
      //       let costSourceTem = this.form.costSource;
      //       if (this.vdui.isNotEmpty(costSourceTem)) {
      //         getPeriodCost({
      //           projectId: this.form.projectId,
      //           periodDateTime: this.form.periodDateTime
      //         }).then(({data}) => {
      //           if (this.operateType === 'add') {
      //             this.form.subjectId = null;
      //           }
      //           const column = this.findObject(this.option.column, 'costBasis');
      //           this.form.costBasis = data.costBasis;
      //         });
      //       }
      //     }
      //     // } else {
      //     //   console.log(123)
      //     //   column.editDisabled = false;
      //     //   column.addDisabled = false;
      //     // }
      //   }
      //   if (this.form.flag === 'edit') {
      //     if (this.form.costSource === 1) {
      //       setTimeout(() => {
      //         const columnCostBasis = this.findObject(this.option.column, 'costBasis');
      //         console.log(columnCostBasis);
      //         columnCostBasis.editDisabled = true;
      //         columnCostBasis.addDisabled = true;
      //       },);
      //     } else {
      //       console.log(123)
      //       const columnCostBasis = this.findObject(this.option.column, 'costBasis');
      //       columnCostBasis.editDisabled = false;
      //       columnCostBasis.addDisabled = false;
      //     }
      //   }
      // },

    },

    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.valuecostbudget_add, false),
          viewBtn: this.vaildData(this.permission.valuecostbudget_view, false),
          delBtn: this.vaildData(this.permission.valuecostbudget_delete, false),
          editBtn: this.vaildData(this.permission.valuecostbudget_edit, false),
        };
      },
    },


    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },

    created() {
      //加载列表
      getProjectList({}).then((res) => {
        this.projectList = res.data;
        // getProjectDict({projectId:this.query.projectId,code:'project_examine_service_type'}).then(({ data }) => {
        //   this.findObject(
        //     this.option.column,
        //     'serviceType'
        //   ).dicData = data;

        if (this.projectList.length > 0) {
          this.projectName = this.projectList[0].name;
          this.query.projectId = this.projectList[0].id;
          this.tempProjectId = this.projectList[0].id;
          getPeriodList({projectId: this.query.projectId}).then(res => {
            const column = this.findObject(this.option.column, 'period');
            //column.dicData = res.data;
            console.log(res.data)
            let arr = [];
            if (this.vdui.isNotEmpty(res.data)) {
              res.data.forEach(ele => {
                //ele = dayjs(ele).format('YYYY')
                let obj = {}
                obj.name = ele;
                obj.value = ele;
                arr.push(obj)
              })
              column.dicData = arr;
            } else {
              column.dicData = [""];
            }
          })
        }
        this.$nextTick(() => {
          this.reWrite = true;
        });
        //this.firstDisplayFlag = true;
      });
    },
    methods: {

      rowStyle(column){
        // 根据条件隐藏显示
        console.log(column);
        if(column.row.releaseFlag===1){
          this.permissionList.delBtn=false;
          this.permissionList.editBtn=false;
        }else {
          this.permissionList.delBtn=true;
          this.permissionList.editBtn=true;
        }

      },

      handleEditGroup(flag) {

        this.tempProjectId = this.form.projectId
        this.handleAction = 2;
        if (flag === "add") {
          this.remainUserList = this.remainMenberUserList;
          this.selectUserType = 1;
          this.dialogUserEditBoxVisible = true;
        } else if (flag === "edit") {
           this.remainUserList = this.remainMenberUserList;
          this.selectUserType = 2;
          this.dialogUserEditBoxVisible = true;
        } else if (flag === "view") {
          // this.remainUserList = this.remainPrincipalUserList;
          this.dialogUserEditBoxVisible = true;
        }
      },
      handleSubmitAction(val) {
        console.log('handleSubmitAction=====>', val);

          this.form.notifyIds = val.idListString;
          this.menberNames = val.nameListString;

          this.dataSelectedMenberUsers = val.dataSelectedUsers;

        this.dialogUserEditBoxVisible = false;
      },

      handleEditAction(val) {
        console.log('handleEditAction=====>', val);

          this.form.notifyIds = val.idListString;
          this.menberNames = val.nameListString;
          console.log(this.form.notifyIds)
          this.remainMenberUserList = val.dataSelectedUsers;

        this.dialogUserEditBoxVisible = false;
      },

      handleCloseAction() {
        this.dialogUserEditBoxVisible = false;
      },

      searchProjectChange(e) {

        this.query.projectId = e;
        getPeriodList({projectId: e}).then(res => {
          const column = this.findObject(this.option.column, 'period');
          //column.dicData = res.data;
          console.log(res.data)
          let arr = [];
          if (this.vdui.isNotEmpty(res.data)) {
            res.data.forEach(ele => {
              //ele = dayjs(ele).format('YYYY')
              let obj = {}
              obj.name = ele;
              obj.value = ele;
              arr.push(obj)
            })
            column.dicData = arr;
          } else {
            column.dicData = [""];
          }
        })
      },
      /*getProjectNameById(projectId) {
        let projectName = '';
        this.projectList.forEach(function (value, index, array) {
          if (value.id === projectId) {
            projectName = value.name;
            return;
          }
        });
        return projectName;
      },*/
      rowSave(row, done, loading) {
        // row.notifyWays = row.notifyWays.join(',');
        // console.log(this.form.notifyIds)
        // row.notifyIds = this.form.notifyIds;
        // row.notifyIds = row.notifyIds.join(',');
        row.periodStart = dayjs(row.periodStart).format('YYYY');
        row.periodEnd = dayjs(row.periodEnd).format('YYYY');
        if (row.periodEnd<row.periodStart){
          this.$message.error('截止周期不可小于起始周期!');
          loading();
          return;
        }
        add(row).then(() => {
          this.emptyForm();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      emptyForm() {
        this.form.id = '';
        this.form.projectId = '';
        this.form.period = '';
        this.form.periodDateTime = '';
        this.form.costSource = '';
        this.form.costBasis = '';
        this.form.sharingCoefficient = '';
        this.form.clinicalEvaluationBase = '';
        this.form.clinicalEvaluationThreshold = '';
        this.form.patientSatisfactionBase = '';
        this.form.patientSatisfactionThreshold = '';
        this.form.releaseFlag = '';
        this.form.attachIds = '';
        this.form.notifyWays = '';
        this.form.notifyIds = '';
        this.menberNames = '';
        this.form.menberNames = '';
        this.remainMenberUserList=[];
        this.form.periodStart='';
        this.form.periodEnd='';
        this.form.targetCost='';
        this.form.targetIncome  ='';


      },
      rowUpdate(row, index, done, loading) {
        // row.notifyWays = row.notifyWays.join(',');
        // row.notifyIds = this.form.notifyIds;
        //row.notifyIds = row.notifyIds.join(',');
        // console.log(row);
        // row.periodDateTime = this.dayjs(row.periodDateTime).format("YYYY-MM-DD 00:00:00")
        row.periodStart = dayjs(row.periodStart).format('YYYY');
        row.periodEnd = dayjs(row.periodEnd).format('YYYY');
        if (row.periodEnd<row.periodStart){
          this.$message.error('截止周期不可小于起始周期!');
          loading();
          return;
        }
        update(row).then(() => {
          this.emptyForm();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      release(row) {
        if (row.releaseFlag == 1) {
          this.$message.warning("该预算已审核！");
          return;
        }
        this.$confirm("是否选择审核", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            return release({id: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success("操作成功!");
          });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        this.form.flag = type;
        console.log(this.form.releaseFlag === 1);
        /*if(this.form.releaseFlag===1){
          const columnPeriodDateTime = this.findObject(this.option.column, 'periodDateTime');
          columnPeriodDateTime.editDisabled = true;
          const columnCostSource = this.findObject(this.option.column, 'costSource');
          columnCostSource.editDisabled = true;
          const columnCostBasis = this.findObject(this.option.column, 'costBasis');
          columnCostBasis.editDisabled = true;
          const columnSharingCoefficient = this.findObject(this.option.column, 'sharingCoefficient');
          columnSharingCoefficient.editDisabled = true;
          const columnClinicalEvaluationBase = this.findObject(this.option.column, 'clinicalEvaluationBase');
          columnClinicalEvaluationBase.editDisabled = true;
          const columnClinicalEvaluationThreshold = this.findObject(this.option.column, 'clinicalEvaluationThreshold');
          columnClinicalEvaluationThreshold.editDisabled = true;
          const columnPatientSatisfactionBase = this.findObject(this.option.column, 'patientSatisfactionBase');
          columnPatientSatisfactionBase.editDisabled = true;
          const columnPatientSatisfactionThreshold = this.findObject(this.option.column, 'patientSatisfactionThreshold');
          columnPatientSatisfactionThreshold.editDisabled = true;
        }*/
        if (type === "view") {
          this.viewFlag = true;
        }
        if (type === "add" || type === "edit") {
          this.viewFlag = false;
        }
        if (["edit", "view"].includes(type)) {

          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
            // this.form.costBasis = data.costBasis;
            // this.form.costSource = data.costSource;
            //
            // let date = dayjs(data.period);
            // this.form.periodDateTime = data.period;
            // this.form.notifyName=data.notifyName;
            // this.remainMenberUserList = data.idNameMap;
            // console.log(this.remainMenberUserList)
            // let idList = [];
            // let idListString = '';
            // let nameList = [];
            // let nameListString = '';
            // data.userList.forEach((ele, i) => {
            //   idList.push(ele.id);
            //   nameList.push(ele.realName);
            // });
            // if (idList.length > 0) {
            //   idListString = idList.join(',');
            //   nameListString = nameList.join(',');
            // }
            //
            // this.form.notifyIds = idListString
            // this.menberNames = nameListString
          });


        } else {
          //this.remainUserList=[];
          setTimeout(() => {
            console.log(this.query.projectId);
            this.form.projectId = this.query.projectId;
          }, 0);
        }
        done();
      },
      beforeClose(done, type) {
        this.emptyForm();

        done();
      },
      searchReset() {
        //this.query.projectId=null;
        this.query.period = null;
        //this.firstDisplayFlag = true;
        this.onLoad();
      },
      searchChange(params, done) {
        params.projectId = this.query.projectId;
        params.projectName = this.query.projectName;
        this.query.period = params.period;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
        if (!this.query.projectId) {
          this.query.projectId = this.query.projectId;
        }
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          /* if (this.firstDisplayFlag) {
             let ent = document.querySelector('input[placeholder="项目名称"]');
             ent.value = this.getProjectNameById(this.query.projectId);
             this.tempProjectId = this.query.projectId
             //关闭默然显示，重刷页面时才开启默认显示
             this.firstDisplayFlag = false;
           }*/
        });
      }
    }
  };
</script>

<style>
</style>
<style lang='scss' scoped>
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
 max-height: calc(100% - 1px);
   max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
